import '../render'
import 'leaflet'
import './lib/leaflet-geojsonext'
import {GeoJSONRenderer} from './lib/geojson-renderer'
import {STATUS_TYPES, MESSAGE_RESPONSE_TYPES} from '../render/constants'
import {onDocumentReady} from '../render/utils'

function init() {
  const renderer = new GeoJSONRenderer()

  document.addEventListener(MESSAGE_RESPONSE_TYPES.markdown, ({detail}: CustomEvent<{data: string}>) => {
    try {
      const parsed = JSON.parse(detail.data)
      renderer.render(parsed)
    } catch (e) {
      renderer.status.set(STATUS_TYPES.error, {error: (e as Error).message})
    }
  })

  renderer.status.set(STATUS_TYPES.markdown)
}

onDocumentReady(init)
